"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepeatBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
const settings = [{
  title: "Repeat Value",
  settings: {
    items: {
      type: "var",
      title: "Value To Repeat",
      variableType: "value",
      description: "The value to repeat for all child blocks. Each value in the list will be added as a variable called 'item' in the children."
    },
    empty: {
      type: "literal",
      title: "Message When Empty",
      valueType: "string",
      description: "Message to show when nothing was found to repeat.",
      default: "Nothing here."
    }
  }
}, {
  title: "Filter",
  settings: {
    filter: {
      type: "conditions",
      title: "Filter Conditions",
      description: "Only include values in the list that meet these conditions.",
      filter: true
    }
  }
}, {
  title: "Display",
  settings: {
    layout: {
      type: "select",
      title: "Repeat Layout",
      enum: ["list", "grid"],
      description: "How to layout repeated children.",
      default: "list"
    }
  }
}];
class RepeatBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "repeat");
    (0, _defineProperty2.default)(this, "listVariable", void 0);
    (0, _defineProperty2.default)(this, "layoutVariable", void 0);
    (0, _defineProperty2.default)(this, "emptyVariable", void 0);
    this.param = param;
    this.listVariable = this.addBlockVariable(variableTypes.get("repeat"), param, ["items", "filter"]);
    this.layoutVariable = this.addBlockVariable(variableTypes.get("literal"), param, [["layout", "value"]]);
    this.emptyVariable = this.addBlockVariable(variableTypes.get("literal"), param, [["empty", "value"]]);
  }
  renderValue() {
    let value = {
      list: _variables.vals.array(this.listVariable.value()),
      layout: _variables.vals.stringValue(this.layoutVariable.value()) || "list",
      empty: _variables.vals.stringValue(this.emptyVariable.value()) || "Nothing here."
    };
    return value;
  }
}
exports.RepeatBlock = RepeatBlock;
(0, _defineProperty2.default)(RepeatBlock, "settings", settings);
//# sourceMappingURL=RepeatBlock.js.map